import { Box, Typography } from "@mui/material"
import { useFolioAmountStyles } from "./foliosAmountStyles"
import { useTranslation } from "react-i18next"

const FoliosAmount = (props: any) => {
  const styles = useFolioAmountStyles()
  const { t } = useTranslation()
  const tracking = props?.row?.isTracking
  return (
    <Box sx={styles.containerFolio}>
      <Typography sx={styles.foliosAmount}>
        {props.current ?? 'N/A'}
      </Typography>
      {!!tracking && (<Typography sx={styles.tracking}>
        {t('general.tracking')}
      </Typography>)}

    </Box>
  )
}

export { FoliosAmount }
